import { useTransaction } from '../../../context/TransactionContext';

interface UseTransactionValidationProps {
  isTransactionTypeRequired: boolean;
  skillRequired?: boolean;
}

/** The required fields, in the order they appear on the form. */
export type InvalidTransactionField = 'matter' | 'transactionType' | 'subject' | 'skill';

export const useTransactionValidation = ({
  isTransactionTypeRequired,
  skillRequired,
}: UseTransactionValidationProps) => {
  const { transaction } = useTransaction();

  const getFirstInvalidField = (): InvalidTransactionField | null => {
    if (!transaction?.matter?.id) return 'matter';
    if (isTransactionTypeRequired && !transaction?.transactionType?.id) return 'transactionType';
    if (!transaction?.currentSubject) return 'subject';
    if (skillRequired && !transaction?.skill?.id) return 'skill';
    return null;
  };

  const validateFields = () => getFirstInvalidField() !== null;

  return {
    validateFields,
    getFirstInvalidField,
  };
};
